import React from 'react';
import ReactDOM from 'react-dom';
import { ScoringEventDto, BreakdownEntry } from './useScoringEvents';
import { ScoreSummaryRow, CodeTypeSection } from './ScoreDetailPanel';
import { s } from './finalCodeset.styles';

type ScorePopoverProps = {
  anchorRect: DOMRect;
  latest: ScoringEventDto;
  onClose: () => void;
};

export function ScorePopover({ anchorRect, latest, onClose }: ScorePopoverProps) {
  const grouped = latest.breakdown.reduce<Record<string, BreakdownEntry[]>>((acc, e) => {
    (acc[e.codeType] ??= []).push(e);
    return acc;
  }, {});
  const ordered = ['cpt', 'icd', 'modifier'].filter(t => grouped[t]);

  return ReactDOM.createPortal(
    <>
      <div style={s.popoverBackdrop} onClick={onClose} />
      <div
        style={{
          ...s.popover,
          top: anchorRect.bottom + 4,
          right: window.innerWidth - anchorRect.right
        }}
        onClick={e => e.stopPropagation()}>
        <ScoreSummaryRow
          score={latest.score}
          overallCategory={latest.overallCategory}
          breakdown={latest.breakdown}
        />
        {latest.breakdown.length === 0 ? (
          <span style={{ fontSize: '12px', color: '#666', fontStyle: 'italic' }}>
            Perfect score — no deductions
          </span>
        ) : (
          ordered.map(t => <CodeTypeSection key={t} codeType={t} entries={grouped[t]} />)
        )}
      </div>
    </>,
    document.body
  );
}
